import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Spinner } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useQuery from "../../Component/devDashboard2/common/useQuery";
import { AuthContext } from "../../context/auth-context";
import {
  fetchCustomerLlms,
  getMarkets,
  getGeographies,
  getLlms,
  getCompMetricsForBrand,
  getCompMetricsForProduct,
} from "../../services/apiService";
import { fetchBrands } from "../../redux/actions/brandsActions";
import { fetchBrandProducts } from "../../redux/actions/brandProductsActions";

import EmptyView from "../../Component/EmptyView/EmptyView";
import { Tabs, Tab, Box, Typography } from "@mui/material";

import {
  calculateAverageData,
  calculateAverageDataStructure,
  getCompetitorMetricData,
  handleInputValidation,
} from "../../utils/monitoring-helpers";
import DashboardNav from "./Form";
import api from "../../BrandOnBoarding/api";
import { useRef } from "react";
import GenericTable from "../../Component/BuyingJourneyDataTable/GenericTable";
import {
  getUniqueAttributes,
  sanitizeObject,
  transformFunnelData,
} from "../../utils/helpers";
import History from "./History/History";
import classes from "./PurchaseJourney.module.css";
import useHistory from "./History/useHistory";

const CONTENT_TYPES = [
  { id: 1, name: "Category" },
  { id: 1, name: "Brand/Product" },
];

const PurchaseFunnel = (props) => {
  const [selectedOptionShow, setSelectedOptionShow] = useState("Company/Brand");
  const value = 0;

  const [showData, setShowData] = useState(false);
  const [isDone, setIsDone] = useState(true);
  const [selectedLlmItems, setSelectedLlmItems] = useState([]);
  const [selectedMarketItems, setSelectedMarketItems] = useState([]);
  const [selectedGeographyItems, setSelectedGeographyItems] = useState([]);
  const [dbLlms, setDbLlms] = useState([]);
  const selectedFrequencyItems = ["Daily"];
  const [selectedContentType, setSelectedContentType] =
    useState("Brand/Product");

  const [brandItems, setBrandItems] = useState([]);
  const [productItems, setProductItems] = useState([]);
  const [selectedBrandItems, setSelectedBrandItems] = useState([]);
  const [selectedProductItems, setSelectedProductItems] = useState([]);

  const [personas, setPersonas] = useState([]);
  const [selectedPersona, setSelectedPersona] = useState([]);

  const [customerLlm, setCustomerLlm] = useState([]);
  const [markets, setMarkets] = useState([]);
  const [geography, setGeography] = useState([]);
  const [purchaseCriterias, setPurchaseCriterias] = useState();
  const [negativeAtts, setNegativeAtts] = useState();
  const [positiveAtts, setPositiveAtts] = useState();
  const [selectedTab, setSelectedTab] = useState("category");
  const [entityCategory, setEntityCategory] = useState("");

  const query = useQuery();

  const frequency = query.get("dateRange");

  const [selectedSubFrequencyItems, setSelectedSubFrequencyItems] = useState(
    frequency || "Current"
  );

  const dispatch = useDispatch();
  const brandProducts = useSelector((state) => state.brandProducts);
  const brands = useSelector((state) => state.brands);

  const { user, authUserEmail } = useContext(AuthContext);

  const customerId = user?.customer_id || 0;

  // content data apis and states

  const [discussionTopics, setDiscussionTopics] = useState(null);

  const [discussionTopicsLoading, setDiscussionTopicsLoading] = useState(false);
  const [childKey, setChildKey] = useState(0);

  const remountChild = () => {
    setChildKey((prev) => prev + 1);
  };

  const [error, setError] = useState();

  const discussionTopicsAbortCtrRef = useRef(null);

  const { addHistory } = useHistory(authUserEmail);

  const updateStatesFromHistory = (data) => {
    setPositiveAtts(data?.json_data?.positiveAtts);
    setNegativeAtts(data?.json_data?.negativeAtts);
    setPurchaseCriterias(data?.json_data?.purchaseCriterias);
    setDiscussionTopics(data?.json_data?.data);
    setShowData(true);
    setIsDone(true);
    setEntityCategory(data?.category);
  };

  const fetchAllMetrics = async (
    payload,
    positive_attributes,
    negative_attributes,
    purchase_criterias
  ) => {
    setError(null);
    const controllers = {
      entity_discussion_topics: new AbortController(),
    };

    discussionTopicsAbortCtrRef.current = controllers.entity_discussion_topics;

    let apiConfigs = [
      {
        key: "entity_discussion_topics",
        url: "/metrics/purchase-journey-data",
        updateFn: setDiscussionTopics,
        setLoading: setDiscussionTopicsLoading,
        controller: controllers.entity_discussion_topics,
      },
    ];

    for (const apiConfig of apiConfigs) {
      apiConfig.setLoading(true);

      (async () => {
        try {
          const response = await api.post(apiConfig.url, payload, {
            signal: apiConfig.controller.signal,
          });
          apiConfig.updateFn(response.data);
          const type = selectedOptionShow === "Product" ? "product" : "brand";
          const dataForHistory = {
            entity: payload?.entity,
            type,
            category: payload?.category,
            data: response?.data,
            negativeAtts: negative_attributes,
            positiveAtts: positive_attributes,
            purchaseCriterias: purchase_criterias,
          };
          const sanitizedData = sanitizeObject(dataForHistory);
          addHistory({
            user_email: authUserEmail,
            name: `${payload?.entity} ${type} Overview`,
            date: Date.now(),
            category: payload?.category,
            type: type,
            entity: payload?.entity,
            is_purchase_journey: true,
            is_conversations: false,
            json_data: sanitizedData,
          });
        } catch (err) {
          if (err.name === "AbortError") {
            console.log(`${apiConfig.key} request aborted`);
          } else {
            setError((prev) => ({
              ...(typeof prev === "object" ? prev : {}),
              [apiConfig.key]: err.message,
            }));
            console.error(`${apiConfig.key} error:`, err);
          }
        } finally {
          apiConfig.setLoading(false);
          remountChild();
        }
      })();
    }
  };

  async function getContentMappingData(
    entity,
    negative_attributes,
    positive_attributes,
    purchase_criterias,
    category
  ) {
    const payload = {
      llm: "gpt-4o",
      category,
      type: selectedOptionShow === "Product" ? "product" : "brand",
      persona: "General Persona",
      location: selectedGeographyItems?.[0] || "",
      entity,
    };
    try {
      await fetchAllMetrics(
        payload,
        positive_attributes,
        negative_attributes,
        purchase_criterias
      );
    } catch (error) {
      console.log(error);
    } finally {
      console.log(error);
    }
  }

  useEffect(() => {
    async function fetchData() {
      const customerSpecificLlms = await fetchCustomerLlms([
        Number(customerId),
      ]);
      setCustomerLlm(customerSpecificLlms?.data);

      let geo = await getGeographies();
      const geographyIds = [
        ...new Set(customerSpecificLlms?.data.map((obj) => obj?.geography_id)),
      ];
      geo = geo?.data.filter((obj) => geographyIds.includes(obj?.id));
      setGeography(geo);

      let market = await getMarkets();
      const filtercustomeLlm = customerSpecificLlms?.data.filter(
        (obj) => obj?.geography_id === 1
      );
      const marketIds = [
        ...new Set(filtercustomeLlm.map((obj) => obj?.market_id)),
      ];
      market = market?.data.filter((obj) => marketIds.includes(obj?.id));
      setMarkets(market);

      if (brandProducts?.data && brandProducts?.data.length === 0) {
        dispatch(fetchBrandProducts(customerId));
      }

      if (brands?.data && brands?.data.length === 0) {
        dispatch(fetchBrands(customerId));
      }

      const llms = await getLlms();
      setDbLlms(llms?.data);
    }

    fetchData();
  }, []);

  useEffect(() => {
    if (selectedOptionShow === "Product") {
      if (
        brandProducts?.data?.data &&
        brandProducts?.data?.data.length !== 0 &&
        dbLlms &&
        dbLlms.length !== 0 &&
        customerLlm &&
        customerLlm.length !== 0 &&
        markets &&
        markets.length !== 0
      ) {
        const activeData = brandProducts?.data?.data.filter(
          (obj) => obj.is_active
        );

        const activeDataProductId = activeData?.[0]?.id;

        const selectedData = brandProducts?.data?.data.filter(
          (obj) => obj.id === activeDataProductId
        );

        setSelectedProductItems([selectedData[0]?.product?.name]);
        setSelectedPersona(["General Persona"]);
        setSelectedLlmItems(["gpt-4o"]);
        setSelectedMarketItems(["General Market"]);
        setSelectedGeographyItems(["USA"]);
        setProductItems(activeData);
        setPersonas(selectedData[0]?.custProduct);
      }
    }
  }, [brandProducts, dbLlms, selectedOptionShow]);

  useEffect(() => {
    if (selectedOptionShow === "Company/Brand") {
      if (
        brands?.data?.data &&
        brands?.data?.data.length !== 0 &&
        dbLlms &&
        dbLlms.length !== 0 &&
        customerLlm &&
        customerLlm.length !== 0 &&
        markets &&
        markets.length !== 0
      ) {
        const activeData = brands?.data?.data?.filter((obj) => obj?.is_active);
        const activeDataBrandId = activeData?.[0]?.id;

        const selectedData = brands?.data?.data?.filter(
          (obj) => obj.id === activeDataBrandId
        );

        setSelectedBrandItems([selectedData[0]?.brand?.name]);
        setSelectedPersona(["General Persona"]);

        setSelectedLlmItems(["gpt-4o"]);
        setSelectedMarketItems(["General Market"]);
        setSelectedGeographyItems(["USA"]);

        setBrandItems(activeData);

        setPersonas(selectedData[0]?.persona);
      }
    }
  }, [brands, dbLlms, selectedOptionShow]);

  useEffect(() => {
    async function fetchCustomerLlmsData() {
      if (
        brandProducts?.data?.data &&
        brandProducts?.data?.data.length !== 0 &&
        selectedProductItems &&
        selectedProductItems.length > 0
      ) {
        const selectedBrandProductCustomerId = brandProducts?.data?.data
          .filter(
            (data) =>
              selectedProductItems.includes(data?.product?.name) &&
              data?.is_active
          )
          .map((obj) => obj?.customer?.id);

        if (selectedBrandProductCustomerId) {
          const customerSpecificLlms = await fetchCustomerLlms(
            selectedBrandProductCustomerId
          );
          // set the customer geographies
          let geo = await getGeographies();
          const geographyIds = [
            ...new Set(
              customerSpecificLlms?.data.map((obj) => obj?.geography_id)
            ),
          ];
          geo = geo?.data.filter((obj) => geographyIds.includes(obj?.id));
          setGeography(geo);

          // set customer geography markets

          let market = await getMarkets();
          const filtercustomeLlm = customerSpecificLlms?.data.filter(
            (obj) => obj?.geography_id === 1
          );
          const marketIds = [
            ...new Set(filtercustomeLlm.map((obj) => obj?.market_id)),
          ];
          market = market?.data.filter((obj) => marketIds.includes(obj?.id));
          setMarkets(market);
          setCustomerLlm(customerSpecificLlms?.data);
          setSelectedGeographyItems(["USA"]);
          setSelectedMarketItems(["General Market"]);
          setSelectedPersona(["General Persona"]);
        }
      }
    }

    fetchCustomerLlmsData();
  }, [selectedProductItems, brandProducts]);

  useEffect(() => {
    async function fetchCustomerLlmsData() {
      if (
        brands?.data?.data &&
        brands?.data?.data.length !== 0 &&
        selectedBrandItems &&
        selectedBrandItems.length > 0
      ) {
        const selectedBrandCustomerId = brands?.data?.data
          .filter(
            (data) =>
              selectedBrandItems.includes(data?.brand?.name) && data?.is_active
          )
          .map((obj) => obj?.customer?.id);

        if (selectedBrandCustomerId) {
          const customerSpecificLlms = await fetchCustomerLlms(
            selectedBrandCustomerId
          );

          // set the customer geographies
          let geo = await getGeographies();
          const geographyIds = [
            ...new Set(
              customerSpecificLlms?.data.map((obj) => obj?.geography_id)
            ),
          ];
          geo = geo?.data.filter((obj) => geographyIds.includes(obj?.id));
          setGeography(geo);

          // set customer geography markets

          let market = await getMarkets();
          const filtercustomeLlm = customerSpecificLlms?.data.filter(
            (obj) => obj?.geography_id === 1
          );
          const marketIds = [
            ...new Set(filtercustomeLlm.map((obj) => obj?.market_id)),
          ];
          market = market?.data.filter((obj) => marketIds.includes(obj?.id));
          setMarkets(market);
          setCustomerLlm(customerSpecificLlms?.data);
          setSelectedGeographyItems(["USA"]);
          setSelectedMarketItems(["General Market"]);
          setSelectedPersona(["General Persona"]);
        }
      }
    }

    fetchCustomerLlmsData();
  }, [selectedBrandItems, brands]);

  const handleLlmCheckChange = (selected) => {
    const selectedValues = selected?.map((option) => option?.name) || [];

    setSelectedLlmItems(selectedValues.at(-1) ? [selectedValues.at(-1)] : []);
  };

  const handlesubFrequencyCheckChange = (key) => {
    setSelectedSubFrequencyItems(key);
  };

  const handleMarketCheckChange = (selected) => {
    let selectedValues = selected?.map((option) => option?.name);
    let lastIndex = selectedValues.length - 1;
    selectedValues = selectedValues?.filter(
      (item, index) => index === lastIndex
    );

    setSelectedMarketItems(selectedValues || []);
  };

  const handleGeographyCheckChange = async (selected) => {
    let selectedValues = selected?.map((option) => option?.name);
    let lastIndex = selectedValues.length - 1;
    selectedValues = selectedValues?.filter(
      (item, index) => index === lastIndex
    );
    const latestValue = selectedValues[selectedValues.length - 1];
    setSelectedGeographyItems(selectedValues || []);

    let geoId = geography.filter((obj) => obj?.name === latestValue)[0]?.id;
    let market = await getMarkets();
    const filtercustomeLlm = customerLlm.filter(
      (obj) => obj?.geography_id === geoId
    );

    if (selectedValues && selectedValues.length === 1) {
      // set customer geography markets

      const marketIds = [
        ...new Set(filtercustomeLlm.map((obj) => obj?.market_id)),
      ];
      market = market?.data.filter((obj) => marketIds.includes(obj?.id));
      setMarkets(market);
    } else if (selectedValues && selectedValues.length > 1) {
      // set customer geography markets

      market = market?.data.filter((obj) => obj?.name === "General Market");
      setMarkets(market);
    }
  };

  const handleProductCheckChange = (selected) => {
    let selectedValues = selected?.map((option) => option?.product?.name);
    let lastIndex = selectedValues.length - 1;
    selectedValues = selectedValues?.filter(
      (item, index) => index === lastIndex
    );
    const latestValue = selectedValues[0];

    setSelectedProductItems(selectedValues || []);
    setSelectedPersona([]);
    const selectedProduct = brandProducts?.data?.data.filter(
      (data) => data?.product?.name === latestValue && data?.is_active
    );

    const persona = selectedProduct[0]?.custProduct;
    setPersonas(persona);
  };

  const handleBrandCheckChange = (selected) => {
    let selectedValues = selected?.map((option) => option?.brand?.name);
    let lastIndex = selectedValues.length - 1;
    selectedValues = selectedValues?.filter(
      (item, index) => index === lastIndex
    );
    const latestValue = selectedValues[0];

    setSelectedBrandItems(selectedValues || []);
    const selectedBrand = brands?.data?.data.filter(
      (data) => data?.brand?.name === latestValue && data?.is_active
    );
    const persona = selectedBrand[0]?.persona;
    setPersonas(persona);
  };

  const handlePersonaCheckChange = (selected) => {
    const selectedValues = selected?.map((option) => option?.persona?.name);
    let lastIndex = selectedValues.length - 1;
    const lastSelectedValue = selectedValues?.filter(
      (item, index) => index === lastIndex
    );
    setSelectedPersona(lastSelectedValue || []);
  };

  const getInputIds = () => {
    const brandId =
      brandItems.filter(
        (item) => item?.brand?.name === selectedBrandItems[0]
      )[0]?.id || null;

    const productId =
      productItems.filter(
        (item) => item?.product?.name === selectedProductItems[0]
      )[0]?.id || null;

    const brandIds = brandItems
      .filter((item) => selectedBrandItems.includes(item?.brand?.name))
      .map((obj) => obj?.id);

    const productIds = productItems
      .filter((item) => selectedProductItems.includes(item?.product?.name))
      .map((obj) => obj?.id);

    const globalLlmId = dbLlms.filter(
      (item) => item?.name === selectedLlmItems[0]
    )[0]?.id;
    const marketId = markets.filter(
      (item) => item?.name === selectedMarketItems[0]
    )[0]?.id;

    const geoId = geography.filter(
      (item) => item?.name === selectedGeographyItems[0]
    )[0]?.id;

    const llmId = customerLlm.filter(
      (item) =>
        item?.llm_id === globalLlmId &&
        item?.market_id === marketId &&
        item?.geography_id === geoId
    )[0]?.id;
    const personaId = personas
      .filter((item) => selectedPersona.includes(item?.persona?.name))
      .map((obj) => obj?.persona_id);

    return {
      brandId,
      brandIds,
      productId,
      productIds,
      globalLlmId,
      llmId,
      personaId,
    };
  };

  const handleClickShow = async () => {
    const error = handleInputValidation(
      selectedOptionShow,
      selectedBrandItems,
      selectedProductItems,
      selectedPersona,
      selectedFrequencyItems,
      value,
      selectedSubFrequencyItems,
      selectedLlmItems,
      selectedGeographyItems,
      selectedMarketItems
    );

    if (error) {
      toast.warn(error, {
        autoClose: 700,
      });
      return;
    }
    const { brandId, brandIds, productId, productIds, llmId, personaId } =
      getInputIds();

    await getCompDashboardDataFromDB(
      brandId,
      productId,
      llmId,
      personaId,
      false,
      undefined,
      undefined,
      undefined,
      brandIds,
      productIds
    );
  };

  const getCustomerLlmInputIds = () => {
    const llmIds = dbLlms
      .filter((item) => selectedLlmItems.includes(item?.name))
      .map((obj) => obj?.id);

    const marketIds = markets
      .filter((item) => selectedMarketItems.includes(item?.name))
      .map((obj) => obj?.id);

    const geoIds = geography
      .filter((item) => selectedGeographyItems.includes(item?.name))
      .map((obj) => obj?.id);

    const customerLlmIds = customerLlm
      .filter(
        (item) =>
          llmIds.includes(item?.llm_id) &&
          marketIds.includes(item?.market_id) &&
          geoIds.includes(item?.geography_id)
      )
      .map((obj) => obj?.id);

    return customerLlmIds;
  };

  const getCompetitorComparisonData = async (
    brandId,
    productId,
    personaId,
    llmId,
    isInitial,
    brandName,
    productName,
    categoryName,
    brandIds,
    productIds
  ) => {
    let result;

    const customerLlmIds = getCustomerLlmInputIds();

    if (selectedOptionShow === "Company/Brand") {
      const payload = {
        brandId: brandId,
        llmId: llmId,
        brandIds: brandIds,
        llmIds: customerLlmIds.length === 0 ? [llmId] : customerLlmIds,
        personaIds: personaId,
        frequency: selectedFrequencyItems[0],
        timePeriod: selectedSubFrequencyItems,
      };

      result = await getCompMetricsForBrand(payload);
    } else {
      const payload = {
        productId: productId,
        llmId: llmId,
        llmIds: customerLlmIds.length === 0 ? [llmId] : customerLlmIds,
        personaIds: personaId,
        productIds: productIds,
        frequency: selectedFrequencyItems[0],
        timePeriod: selectedSubFrequencyItems,
      };

      result = await getCompMetricsForProduct(payload);
    }

    const {
      categoryDimdata,
      attributesData,
      selectedBrandCategory,
      selectedBrandProductCategory,
    } = getCompetitorMetricData(
      result,
      selectedOptionShow,
      selectedBrandItems,
      selectedProductItems,
      brandName,
      productName,
      selectedSubFrequencyItems,
      brands,
      brandProducts
    );

    const positiveAtt = calculateAverageData(attributesData?.mergedData)?.[
      "avg"
    ];
    const negativeAtt = calculateAverageData(
      attributesData?.negativeAttributesMergedData
    )?.["avg"];

    const entity =
      selectedOptionShow === "Product"
        ? selectedProductItems?.[0]
        : selectedBrandItems?.[0];

    const category =
      selectedOptionShow === "Product"
        ? selectedBrandProductCategory
        : selectedBrandCategory;

    const purchase_criterias = Object.entries(
      calculateAverageDataStructure?.(categoryDimdata)?.avg?.[entity] || {}
    )
      .filter(([_, value]) => value?.avgValue <= 10)
      .map(([key]) => key);
    const positive_attributes = getUniqueAttributes(positiveAtt, entity)?.slice(
      0,
      10
    );
    const negative_attributes = getUniqueAttributes(negativeAtt, entity)?.slice(
      0,
      10
    );

    setNegativeAtts(negative_attributes);
    setPositiveAtts(positive_attributes);
    setPurchaseCriterias(purchase_criterias);
    setEntityCategory(category);

    return {
      entity,
      category,
      negative_attributes,
      positive_attributes,
      purchase_criterias,
    };
  };

  const getCompDashboardDataFromDB = async (
    brandId,
    productId,
    llmId,
    personaId,
    isInitial,
    brandName,
    productName,
    categoryName,
    brandIds,
    productIds
  ) => {
    setShowData(false);
    setIsDone(false);

    try {
      const {
        entity,
        negative_attributes,
        positive_attributes,
        purchase_criterias,
        category,
      } = await getCompetitorComparisonData(
        brandId,
        productId,
        personaId,
        llmId,
        isInitial,
        brandName,
        productName,
        categoryName,
        brandIds,
        productIds
      );
      await getContentMappingData(
        entity,
        negative_attributes,
        positive_attributes,
        purchase_criterias,
        category
      );
    } catch (err) {
    } finally {
      setShowData(true);
      setIsDone(true);
    }
  };

  const handleContentTypeChange = (selected) => {
    let selectedValues = selected?.map((option) => option?.name);
    let lastIndex = selectedValues.length - 1;
    selectedValues = selectedValues?.filter(
      (item, index) => index === lastIndex
    );
    setSelectedContentType(selectedValues?.[0] || "");
    // setShowData(false);
  };

  if (
    selectedOptionShow === "Product" &&
    brandProducts?.data?.data &&
    !brandProducts?.data?.data.length
  ) {
    return <EmptyView message="No Products Found" />;
  }

  const TableWrapper = ({
    data,
    title,
    loading,
    error,
    minWidth = "99%",
    sources,
  }) => (
    <div style={{ flex: 1, minWidth }}>
      <GenericTable
        sources={sources}
        data={data}
        loading={loading}
        title={title}
        error={error}
      />
    </div>
  );

  const brandProductLabel =
    selectedOptionShow === "Product"
      ? `${selectedOptionShow} (${selectedProductItems?.[0]})` || ""
      : `${selectedOptionShow} (${selectedBrandItems?.[0]})` || "";

  const tabOptions = [
    { label: `Category (${entityCategory})`, value: "category" },
    { label: brandProductLabel, value: "brand_product" },
  ];

  return (
    <div className="bodycontent">
      <div className={classes.section_summary}>
        <div>
          <DashboardNav
            contentTypes={CONTENT_TYPES}
            selectedContentType={selectedContentType}
            handleContentTypeChange={handleContentTypeChange}
            selectedOptionShow={selectedOptionShow}
            brandItems={brandItems}
            selectedBrandItems={selectedBrandItems}
            handleBrandCheckChange={handleBrandCheckChange}
            handleProductCheckChange={handleProductCheckChange}
            selectedProductItems={selectedProductItems}
            productItems={productItems}
            selectedPersona={selectedPersona}
            handlePersonaCheckChange={handlePersonaCheckChange}
            personas={personas}
            selectedGeographyItems={selectedGeographyItems}
            handleGeographyCheckChange={handleGeographyCheckChange}
            geography={geography}
            selectedMarketItems={selectedMarketItems}
            handleMarketCheckChange={handleMarketCheckChange}
            markets={markets}
            selectedLlmItems={selectedLlmItems}
            handleLlmCheckChange={handleLlmCheckChange}
            dbLlms={dbLlms}
            selectedSubFrequencyItems={selectedSubFrequencyItems}
            handlesubFrequencyCheckChange={handlesubFrequencyCheckChange}
            showData={showData}
            isDone={isDone}
            handleClickShow={handleClickShow}
            setSelectedOptionShow={setSelectedOptionShow}
          />
        </div>
        <div className={` ${classes.history}`}>
          <History
            key={childKey}
            filter={selectedOptionShow === "Product" ? "product" : "brand"}
            updateStatesFromHistory={updateStatesFromHistory}
          />
        </div>
      </div>

      <div>
        {!showData && !isDone && (
          <div
            style={{
              fontSize: "22px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "20px",
              //   fontWeight: "bold",
            }}
          >
            <Spinner
              as="span"
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
            />{" "}
            &nbsp;
            {`Preparing Data, Please Wait...`}
          </div>
        )}
        {showData && isDone && (
          <>
            <div>
              <Box sx={{ width: "100%" }}>
                <Tabs
                  value={selectedTab}
                  onChange={(event, newValue) => setSelectedTab(newValue)}
                  centered
                >
                  {tabOptions.map((tab) => (
                    <Tab key={tab.value} label={tab.label} value={tab.value} />
                  ))}
                </Tabs>
              </Box>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "0.5rem",
                }}
              >
                {selectedTab === "brand_product" && (
                  <>
                    <TableWrapper
                      data={
                        discussionTopics?.discussionTopics
                          ?.entity_discussion_topics
                      }
                      title="Brand Discussion Topics"
                      loading={discussionTopicsLoading}
                      sources={
                        discussionTopics?.discussionTopics
                          ?.entity_discussion_topics_sources
                      }
                    />
                    <TableWrapper
                      data={positiveAtts}
                      title="Positive Attributes"
                      loading={discussionTopicsLoading}
                      minWidth="49%"
                    />

                    <TableWrapper
                      data={negativeAtts}
                      title="Negative Attributes"
                      minWidth="49%"
                      loading={discussionTopicsLoading}
                    />

                    <TableWrapper
                      data={discussionTopics?.purchaseEnablers?.entity_data}
                      title="Purchase Enablers"
                      loading={discussionTopicsLoading}
                      sources={
                        discussionTopics?.purchaseEnablers?.entity_data_sources
                      }
                    />

                    <TableWrapper
                      data={discussionTopics?.purchaseBarriers?.entity_data}
                      title="Purchase Barriers"
                      loading={discussionTopicsLoading}
                      sources={
                        discussionTopics?.purchaseBarriers?.entity_data_sources
                      }
                    />
                    <TableWrapper
                      data={transformFunnelData(
                        discussionTopics?.purchaseJourneyQuestions
                          ?.entity_questions?.questions_by_funnel_stage
                      )}
                      title="Buying Journey Prompts"
                      loading={discussionTopicsLoading}
                    />
                  </>
                )}

                {selectedTab === "category" && (
                  <>
                    <TableWrapper
                      data={
                        discussionTopics?.discussionTopics?.discussion_topics
                      }
                      title="Category Discussion Topics"
                      loading={discussionTopicsLoading}
                      sources={
                        discussionTopics?.discussionTopics
                          ?.discussion_topics_sources
                      }
                    />
                    <TableWrapper
                      data={purchaseCriterias}
                      title="Purchase Criterias"
                      minWidth="19%"
                      loading={discussionTopicsLoading}
                    />

                    <TableWrapper
                      data={discussionTopics?.purchaseBarriers?.entity_data}
                      title="Purchase Barriers"
                      loading={discussionTopicsLoading}
                      minWidth="79%"
                      sources={
                        discussionTopics?.purchaseBarriers?.entity_data_sources
                      }
                    />

                    <TableWrapper
                      data={discussionTopics?.topPlayersAnalysis?.data}
                      title="Top Player Analysis"
                      loading={discussionTopicsLoading}
                    />

                    <TableWrapper
                      data={transformFunnelData(
                        discussionTopics?.purchaseJourneyQuestions
                          ?.category_questions?.questions_by_funnel_stage
                      )}
                      title="Buying Journey Prompts"
                      loading={discussionTopicsLoading}
                    />
                  </>
                )}
              </div>
            </div>
          </>
        )}
      </div>

      <ToastContainer />
    </div>
  );
};

export default PurchaseFunnel;
